/**
 * Parses a Chargebee error message and returns an object containing the error message and code.
 * @param {string} errorMessage - the error message to parse
 * @return {{message: string, code: string} | null} an object containing the error message and code, or null if the input does not match the expected format
 * @example
 * const errorMessage =
 * 	'An error occurred while processing your card. Try again in a little bit.; code: processing_error;';
 * const errorObject = parseErrorMessage(errorMessage);
 *
 * if (errorObject) {
 * 	console.log(errorObject);
 * } else {
 * 	console.log('Invalid error message format.');
 * }
 */

const capitalizeWord = (word: string) => {
  return word.slice(0, 1).toUpperCase() + word.slice(1);
};
export function parseChargebeeErrorMessage(errorMessage: string) {
  const messageRegex = /^(.*?)(?=;|$)/;
  const codeRegex = /code:\s*([^;]+)/;

  const messageMatch = errorMessage.match(messageRegex);
  const codeMatch = errorMessage.match(codeRegex);

  if (messageMatch && codeMatch) {
    const message = messageMatch[1].trim();
    const rawCode = codeMatch[1].trim();
    const code = rawCode
      .replace(/_/g, ' ')
      .split(' ')
      .map((code) => capitalizeWord(code))
      .join(' ');

    return { message, code };
  } else {
    return {
      message: '',
      code: '',
    };
  }
}
